import { render, staticRenderFns } from "./CurrentStatus.vue?vue&type=template&id=1ad132c7&scoped=true&"
import script from "./CurrentStatus.vue?vue&type=script&lang=ts&"
export * from "./CurrentStatus.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentStatus.vue?vue&type=style&index=0&id=1ad132c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad132c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad132c7')) {
      api.createRecord('1ad132c7', component.options)
    } else {
      api.reload('1ad132c7', component.options)
    }
    module.hot.accept("./CurrentStatus.vue?vue&type=template&id=1ad132c7&scoped=true&", function () {
      api.rerender('1ad132c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Live/CurrentStatus.vue"
export default component.exports